// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const API_ERROR_CODE_I18N_KEY_MAP: Record<string, string> = {
  "account.access.api_empty_response": "common.errors.apiCodes.accountAccessApiEmptyResponse",
  "admin.access.api_empty_response": "common.errors.apiCodes.adminAccessApiEmptyResponse",
  "aitest.auth.invalid_sso_user_payload": "common.errors.apiCodes.aitestAuthInvalidSsoUserPayload",
  "aitest.auth.invalid_token": "common.errors.apiCodes.aitestAuthInvalidToken",
  "aitest.auth.management_access_required":
    "common.errors.apiCodes.aitestAuthManagementAccessRequired",
  "aitest.auth.member_access_required": "common.errors.apiCodes.aitestAuthMemberAccessRequired",
  "aitest.auth.missing_bearer_token": "common.errors.apiCodes.aitestAuthMissingBearerToken",
  "aitest.auth.sso_integration_disabled": "common.errors.apiCodes.aitestAuthSsoIntegrationDisabled",
  "aitest.auth.sso_unavailable": "common.errors.apiCodes.aitestAuthSsoUnavailable",
  "aitest.identity_contract_invalid": "common.errors.apiCodes.aitestIdentityContractInvalid",
  "aitest.member_contract_invalid": "common.errors.apiCodes.aitestMemberContractInvalid",
  "aitest.member.data_contract_invalid": "common.errors.apiCodes.aitestMemberDataContractInvalid",
  "aitest.member.invalid_roles": "common.errors.apiCodes.aitestMemberInvalidRoles",
  "aitest.member.not_found": "common.errors.apiCodes.aitestMemberNotFound",
  "aitest.member.username_required": "common.errors.apiCodes.aitestMemberUsernameRequired",
  "aitest.orchestrator.create_request_id_required":
    "common.errors.apiCodes.aitestOrchestratorCreateRequestIdRequired",
  "aitest.orchestrator.execution_fabric_base_url_missing":
    "common.errors.apiCodes.aitestOrchestratorExecutionFabricBaseUrlMissing",
  "aitest.orchestrator.execution_fabric_internal_token_missing":
    "common.errors.apiCodes.aitestOrchestratorExecutionFabricInternalTokenMissing",
  "aitest.orchestrator.execution_fabric_payload_invalid":
    "common.errors.apiCodes.aitestOrchestratorExecutionFabricPayloadInvalid",
  "aitest.orchestrator.execution_fabric_rejected":
    "common.errors.apiCodes.aitestOrchestratorExecutionFabricRejected",
  "aitest.orchestrator.execution_fabric_request_failed":
    "common.errors.apiCodes.aitestOrchestratorExecutionFabricRequestFailed",
  "aitest.orchestrator.instance_id_invalid":
    "common.errors.apiCodes.aitestOrchestratorInstanceIdInvalid",
  "aitest.orchestrator.operator_context_missing":
    "common.errors.apiCodes.aitestOrchestratorOperatorContextMissing",
  "aitest.orchestrator.orchestrator_center_base_url_missing":
    "common.errors.apiCodes.aitestOrchestratorOrchestratorCenterBaseUrlMissing",
  "aitest.orchestrator.orchestrator_center_contract_invalid":
    "common.errors.apiCodes.aitestOrchestratorOrchestratorCenterContractInvalid",
  "aitest.orchestrator.orchestrator_center_internal_token_missing":
    "common.errors.apiCodes.aitestOrchestratorOrchestratorCenterInternalTokenMissing",
  "aitest.orchestrator.orchestrator_center_payload_invalid":
    "common.errors.apiCodes.aitestOrchestratorOrchestratorCenterPayloadInvalid",
  "aitest.orchestrator.orchestrator_center_rejected":
    "common.errors.apiCodes.aitestOrchestratorOrchestratorCenterRejected",
  "aitest.orchestrator.orchestrator_center_request_failed":
    "common.errors.apiCodes.aitestOrchestratorOrchestratorCenterRequestFailed",
  "aitest.orchestrator.request_id_required":
    "common.errors.apiCodes.aitestOrchestratorRequestIdRequired",
  "aitest.platform.data_contract_invalid":
    "common.errors.apiCodes.aitestPlatformDataContractInvalid",
  "aitest.smart_asset.agent_template_delete_conflict":
    "common.errors.apiCodes.aitestSmartAssetAgentTemplateDeleteConflict",
  "aitest.smart_asset.agent_template_not_found":
    "common.errors.apiCodes.aitestSmartAssetAgentTemplateNotFound",
  "aitest.smart_asset.assembly_status_invalid":
    "common.errors.apiCodes.aitestSmartAssetAssemblyStatusInvalid",
  "aitest.smart_asset.identifier_exists": "common.errors.apiCodes.aitestSmartAssetIdentifierExists",
  "aitest.smart_asset.invalid_status": "common.errors.apiCodes.aitestSmartAssetInvalidStatus",
  "aitest.smart_asset.invalid_transport_type":
    "common.errors.apiCodes.aitestSmartAssetInvalidTransportType",
  "aitest.smart_asset.mcp_delete_agent_conflict":
    "common.errors.apiCodes.aitestSmartAssetMcpDeleteAgentConflict",
  "aitest.smart_asset.mcp_delete_task_conflict":
    "common.errors.apiCodes.aitestSmartAssetMcpDeleteTaskConflict",
  "aitest.smart_asset.mcp_not_found": "common.errors.apiCodes.aitestSmartAssetMcpNotFound",
  "aitest.smart_asset.required_field": "common.errors.apiCodes.aitestSmartAssetRequiredField",
  "aitest.smart_asset.skill_delete_agent_conflict":
    "common.errors.apiCodes.aitestSmartAssetSkillDeleteAgentConflict",
  "aitest.smart_asset.skill_delete_task_conflict":
    "common.errors.apiCodes.aitestSmartAssetSkillDeleteTaskConflict",
  "aitest.smart_asset.skill_not_found": "common.errors.apiCodes.aitestSmartAssetSkillNotFound",
  "aitest.smart_asset.summary_contract_invalid":
    "common.errors.apiCodes.aitestSmartAssetSummaryContractInvalid",
  "aitest.smart_asset.unknown_mcp_identifiers":
    "common.errors.apiCodes.aitestSmartAssetUnknownMcpIdentifiers",
  "aitest.smart_asset.unknown_skill_identifiers":
    "common.errors.apiCodes.aitestSmartAssetUnknownSkillIdentifiers",
  "aitest.target.reference_sync_failed": "common.errors.apiCodes.aitestTargetReferenceSyncFailed",
  "aitest.test_task.execution_truth_frozen":
    "common.errors.apiCodes.aitestTestTaskExecutionTruthFrozen",
  "aitest.test_task.manual_leader_summary_required":
    "common.errors.apiCodes.aitestTestTaskManualLeaderSummaryRequired",
  "aitest.test_task.manual_reports_incomplete":
    "common.errors.apiCodes.aitestTestTaskManualReportsIncomplete",
  "aitest.test_task.not_found": "common.errors.apiCodes.aitestTestTaskNotFound",
  "application_images.contract.node_local_inventory_items_missing":
    "common.errors.apiCodes.applicationImagesContractNodeLocalInventoryItemsMissing",
  "application_images.contract.parameter_schema_invalid":
    "common.errors.apiCodes.applicationImagesContractParameterSchemaInvalid",
  "asset.identifier_missing": "common.errors.apiCodes.platformAssetCenterAssetIdentifierMissing",
  "asset.object_space_grant_create_failed":
    "common.errors.apiCodes.platformAssetCenterObjectSpaceGrantCreateFailed",
  "asset.object_space_not_selected":
    "common.errors.apiCodes.platformAssetCenterObjectSpaceNotSelected",
  "asset.public_identifier_missing":
    "common.errors.apiCodes.platformAssetCenterAssetPublicIdentifierMissing",
  "ctf.auth.data_contract_invalid": "common.errors.apiCodes.ctfAuthDataContractInvalid",
  "ctf.auth.member_access_required": "common.errors.apiCodes.ctfAuthMemberAccessRequired",
  "ctf.auth.member_inactive": "common.errors.apiCodes.ctfAuthMemberInactive",
  "ctf.business_event.inbox_retry_later": "common.errors.apiCodes.ctfBusinessEventInboxRetryLater",
  "ctf.business_event.unexpected_retryable_failure":
    "common.errors.apiCodes.ctfBusinessEventUnexpectedRetryableFailure",
  "ctf.member.already_exists": "common.errors.apiCodes.ctfMemberAlreadyExists",
  "ctf.member.duplicate_user_id": "common.errors.apiCodes.ctfMemberDuplicateUserId",
  "ctf.member.invalid_roles": "common.errors.apiCodes.ctfMemberInvalidRoles",
  "ctf.member.not_found": "common.errors.apiCodes.ctfMemberNotFound",
  "ctf.member.user_id_required": "common.errors.apiCodes.ctfMemberUserIdRequired",
  "ctf.member.username_required": "common.errors.apiCodes.ctfMemberUsernameRequired",
  "ctf.platform.application_not_found": "common.errors.apiCodes.ctfPlatformApplicationNotFound",
  "ctf.platform.data_contract_invalid": "common.errors.apiCodes.ctfPlatformDataContractInvalid",
  "edu.auth.data_contract_invalid": "common.errors.apiCodes.eduAuthDataContractInvalid",
  "edu.auth.member_access_required": "common.errors.apiCodes.eduAuthMemberAccessRequired",
  "edu.dependency.database_unavailable": "common.errors.apiCodes.eduDependencyDatabaseUnavailable",
  "edu.platform.application_not_found": "common.errors.apiCodes.eduPlatformApplicationNotFound",
  "edu.platform.data_contract_invalid": "common.errors.apiCodes.eduPlatformDataContractInvalid",
  "environment.base_image_asset_required":
    "common.errors.apiCodes.environmentBaseImageAssetRequired",
  "environment.container_image_application_contract_json_invalid":
    "common.errors.apiCodes.environmentContainerImageApplicationContractJsonInvalid",
  "environment.container_image_application_contract_json_invalid_shape":
    "common.errors.apiCodes.environmentContainerImageApplicationContractJsonInvalidShape",
  "environment.container_image_archived_readonly":
    "common.errors.apiCodes.environmentContainerImageArchivedReadonly",
  "environment.container_image_import_namespace_mismatch":
    "common.errors.apiCodes.environmentContainerImageImportNamespaceMismatch",
  "environment.container_image_import_parsed_name_missing":
    "common.errors.apiCodes.environmentContainerImageImportParsedNameMissing",
  "environment.container_image_import_task_failed":
    "common.errors.apiCodes.environmentContainerImageImportTaskFailed",
  "environment.container_image_import_task_id_invalid":
    "common.errors.apiCodes.environmentContainerImageImportTaskIdInvalid",
  "environment.container_image_import_task_id_missing":
    "common.errors.apiCodes.environmentContainerImageImportTaskIdMissing",
  "environment.container_image_import_task_timeout":
    "common.errors.apiCodes.environmentContainerImageImportTaskTimeout",
  "exam.attempt_question.not_found": "common.errors.apiCodes.examAttemptQuestionNotFound",
  "exam.attempt.forbidden": "common.errors.apiCodes.examAttemptForbidden",
  "exam.attempt.not_found": "common.errors.apiCodes.examAttemptNotFound",
  "exam.auth.account_locked": "common.errors.apiCodes.examAuthAccountLocked",
  "exam.auth.captcha_invalid": "common.errors.apiCodes.examAuthCaptchaInvalid",
  "exam.auth.captcha_required": "common.errors.apiCodes.examAuthCaptchaRequired",
  "exam.auth.credentials_invalid": "common.errors.apiCodes.examAuthCredentialsInvalid",
  "exam.auth.current_password_incorrect": "common.errors.apiCodes.examAuthCurrentPasswordIncorrect",
  "exam.auth.invalid_refresh_token": "common.errors.apiCodes.examAuthInvalidRefreshToken",
  "exam.auth.ip_not_allowed": "common.errors.apiCodes.examAuthIpNotAllowed",
  "exam.auth.password_reuse_disallowed": "common.errors.apiCodes.examAuthPasswordReuseDisallowed",
  "exam.auth.permission_denied": "common.errors.apiCodes.examAuthPermissionDenied",
  "exam.candidate_import.dependency_unavailable":
    "common.errors.apiCodes.examCandidateImportDependencyUnavailable",
  "exam.candidate_import.template_generation_failed":
    "common.errors.apiCodes.examCandidateImportTemplateGenerationFailed",
  "exam.candidate_import.validation_failed":
    "common.errors.apiCodes.examCandidateImportValidationFailed",
  "exam.candidate_user.invalid": "common.errors.apiCodes.examCandidateUserInvalid",
  "exam.candidate_user.not_found": "common.errors.apiCodes.examCandidateUserNotFound",
  "exam.candidate.has_attempt": "common.errors.apiCodes.examCandidateHasAttempt",
  "exam.candidate.not_assigned": "common.errors.apiCodes.examCandidateNotAssigned",
  "exam.custom_field.not_found": "common.errors.apiCodes.examCustomFieldNotFound",
  "exam.custom_field.validation_failed": "common.errors.apiCodes.examCustomFieldValidationFailed",
  "exam.entry.code_conflict": "common.errors.apiCodes.examEntryCodeConflict",
  "exam.entry.not_found": "common.errors.apiCodes.examEntryNotFound",
  "exam.entry.required": "common.errors.apiCodes.examEntryRequired",
  "exam.entry.subdomain_conflict": "common.errors.apiCodes.examEntrySubdomainConflict",
  "exam.environment_instance.not_found": "common.errors.apiCodes.examEnvironmentInstanceNotFound",
  "exam.environment.callback.instance_destroyed":
    "common.errors.apiCodes.examEnvironmentCallbackInstanceDestroyed",
  "exam.environment.callback.token_mismatch":
    "common.errors.apiCodes.examEnvironmentCallbackTokenMismatch",
  "exam.environment.callback.token_required":
    "common.errors.apiCodes.examEnvironmentCallbackTokenRequired",
  "exam.environment.candidate.concurrent_limit_exceeded":
    "common.errors.apiCodes.examEnvironmentCandidateConcurrentLimitExceeded",
  "exam.environment.candidate.total_creation_limit_exceeded":
    "common.errors.apiCodes.examEnvironmentCandidateTotalCreationLimitExceeded",
  "exam.environment.docker_image.archive_invalid":
    "common.errors.apiCodes.examEnvironmentDockerImageArchiveInvalid",
  "exam.environment.docker_image.archive_not_found":
    "common.errors.apiCodes.examEnvironmentDockerImageArchiveNotFound",
  "exam.environment.docker_image.archive_too_large":
    "common.errors.apiCodes.examEnvironmentDockerImageArchiveTooLarge",
  "exam.environment.docker_image.asset_import_failed":
    "common.errors.apiCodes.examEnvironmentDockerImageAssetImportFailed",
  "exam.environment.docker_image.build_failed":
    "common.errors.apiCodes.examEnvironmentDockerImageBuildFailed",
  "exam.environment.docker_image.build_timeout":
    "common.errors.apiCodes.examEnvironmentDockerImageBuildTimeout",
  "exam.environment.docker_image.data_contract_invalid":
    "common.errors.apiCodes.examEnvironmentDockerImageDataContractInvalid",
  "exam.environment.docker_image.default_port_invalid":
    "common.errors.apiCodes.examEnvironmentDockerImageDefaultPortInvalid",
  "exam.environment.docker_image.default_port_not_declared":
    "common.errors.apiCodes.examEnvironmentDockerImageDefaultPortNotDeclared",
  "exam.environment.docker_image.dockerfile_required":
    "common.errors.apiCodes.examEnvironmentDockerImageDockerfileRequired",
  "exam.environment.docker_image.dockerfile_too_large":
    "common.errors.apiCodes.examEnvironmentDockerImageDockerfileTooLarge",
  "exam.environment.docker_image.execution_center_required":
    "common.errors.apiCodes.examEnvironmentDockerImageExecutionCenterRequired",
  "exam.environment.docker_image.image_required":
    "common.errors.apiCodes.examEnvironmentDockerImageImageRequired",
  "exam.environment.docker_image.not_found":
    "common.errors.apiCodes.examEnvironmentDockerImageNotFound",
  "exam.environment.docker_image.runtime_unavailable":
    "common.errors.apiCodes.examEnvironmentDockerImageRuntimeUnavailable",
  "exam.environment.docker_instance.container_id_required":
    "common.errors.apiCodes.examEnvironmentDockerInstanceContainerIdRequired",
  "exam.environment.docker_instance.data_contract_invalid":
    "common.errors.apiCodes.examEnvironmentDockerInstanceDataContractInvalid",
  "exam.environment.docker_instance.image_required":
    "common.errors.apiCodes.examEnvironmentDockerInstanceImageRequired",
  "exam.environment.evaluation.data_contract_invalid":
    "common.errors.apiCodes.examEnvironmentEvaluationDataContractInvalid",
  "exam.environment.evaluation.instance_destroyed":
    "common.errors.apiCodes.examEnvironmentEvaluationInstanceDestroyed",
  "exam.environment.evaluation.local_workspace_unavailable":
    "common.errors.apiCodes.examEnvironmentEvaluationLocalWorkspaceUnavailable",
  "exam.environment.evaluation.self_check_disabled":
    "common.errors.apiCodes.examEnvironmentEvaluationSelfCheckDisabled",
  "exam.environment.evaluation.self_check_limit_exceeded":
    "common.errors.apiCodes.examEnvironmentEvaluationSelfCheckLimitExceeded",
  "exam.environment.execution_fabric.configuration_missing":
    "common.errors.apiCodes.examEnvironmentExecutionFabricConfigurationMissing",
  "exam.environment.flag_validation.active_instance_required":
    "common.errors.apiCodes.examEnvironmentFlagValidationActiveInstanceRequired",
  "exam.environment.flag_validation.instance_destroyed":
    "common.errors.apiCodes.examEnvironmentFlagValidationInstanceDestroyed",
  "exam.environment.flag_validation.question_type_not_supported":
    "common.errors.apiCodes.examEnvironmentFlagValidationQuestionTypeNotSupported",
  "exam.environment.instance.container_port_invalid":
    "common.errors.apiCodes.examEnvironmentInstanceContainerPortInvalid",
  "exam.environment.instance.creation_limit_exceeded":
    "common.errors.apiCodes.examEnvironmentInstanceCreationLimitExceeded",
  "exam.environment.instance.data_contract_invalid":
    "common.errors.apiCodes.examEnvironmentInstanceDataContractInvalid",
  "exam.environment.instance.image_required":
    "common.errors.apiCodes.examEnvironmentInstanceImageRequired",
  "exam.environment.instance.init_script_unsupported":
    "common.errors.apiCodes.examEnvironmentInstanceInitScriptUnsupported",
  "exam.environment.instance.question_type_not_supported":
    "common.errors.apiCodes.examEnvironmentInstanceQuestionTypeNotSupported",
  "exam.environment.node_runtime.data_contract_invalid":
    "common.errors.apiCodes.examEnvironmentNodeRuntimeDataContractInvalid",
  "exam.environment.node_runtime.request_failed":
    "common.errors.apiCodes.examEnvironmentNodeRuntimeRequestFailed",
  "exam.environment.node_runtime.unavailable":
    "common.errors.apiCodes.examEnvironmentNodeRuntimeUnavailable",
  "exam.environment.orchestrator.handoff_failed":
    "common.errors.apiCodes.examEnvironmentOrchestratorHandoffFailed",
  "exam.environment.practical_session.container_id_required":
    "common.errors.apiCodes.examEnvironmentPracticalSessionContainerIdRequired",
  "exam.environment.practical_session.question_type_not_supported":
    "common.errors.apiCodes.examEnvironmentPracticalSessionQuestionTypeNotSupported",
  "exam.environment.task_center.data_contract_invalid":
    "common.errors.apiCodes.examEnvironmentTaskCenterDataContractInvalid",
  "exam.environment.task_center.execution_center_required":
    "common.errors.apiCodes.examEnvironmentTaskCenterExecutionCenterRequired",
  "exam.environment.task_center.handoff_failed":
    "common.errors.apiCodes.examEnvironmentTaskCenterHandoffFailed",
  "exam.exam.archived_edit_forbidden": "common.errors.apiCodes.examExamArchivedEditForbidden",
  "exam.exam.assigned_candidates_required":
    "common.errors.apiCodes.examExamAssignedCandidatesRequired",
  "exam.exam.candidate_assignment_forbidden":
    "common.errors.apiCodes.examExamCandidateAssignmentForbidden",
  "exam.exam.code_not_found": "common.errors.apiCodes.examExamCodeNotFound",
  "exam.exam.code_required": "common.errors.apiCodes.examExamCodeRequired",
  "exam.exam.delete_requires_draft": "common.errors.apiCodes.examExamDeleteRequiresDraft",
  "exam.exam.duration_required": "common.errors.apiCodes.examExamDurationRequired",
  "exam.exam.field_invalid": "common.errors.apiCodes.examExamFieldInvalid",
  "exam.exam.forbidden": "common.errors.apiCodes.examExamForbidden",
  "exam.exam.has_attempt_records": "common.errors.apiCodes.examExamHasAttemptRecords",
  "exam.exam.not_found": "common.errors.apiCodes.examExamNotFound",
  "exam.exam.paper_version_change_forbidden":
    "common.errors.apiCodes.examExamPaperVersionChangeForbidden",
  "exam.exam.requires_ended_status": "common.errors.apiCodes.examExamRequiresEndedStatus",
  "exam.exam.running_attempts_exist": "common.errors.apiCodes.examExamRunningAttemptsExist",
  "exam.exam.status_transition_invalid": "common.errors.apiCodes.examExamStatusTransitionInvalid",
  "exam.exam.status_update_forbidden": "common.errors.apiCodes.examExamStatusUpdateForbidden",
  "exam.exam.unsupported_status_action": "common.errors.apiCodes.examExamUnsupportedStatusAction",
  "exam.judge_service.invalid_response": "common.errors.apiCodes.examJudgeServiceInvalidResponse",
  "exam.judge_service.request_failed": "common.errors.apiCodes.examJudgeServiceRequestFailed",
  "exam.judge_service.unavailable": "common.errors.apiCodes.examJudgeServiceUnavailable",
  "exam.judge.data_contract_invalid": "common.errors.apiCodes.examJudgeDataContractInvalid",
  "exam.judge.question_type_not_supported":
    "common.errors.apiCodes.examJudgeQuestionTypeNotSupported",
  "exam.judge.runtime_unavailable": "common.errors.apiCodes.examJudgeRuntimeUnavailable",
  "exam.judge.source_code_not_found": "common.errors.apiCodes.examJudgeSourceCodeNotFound",
  "exam.judge.submission_not_found": "common.errors.apiCodes.examJudgeSubmissionNotFound",
  "exam.judge.unsupported_language": "common.errors.apiCodes.examJudgeUnsupportedLanguage",
  "exam.platform.application_not_found": "common.errors.apiCodes.examPlatformApplicationNotFound",
  "exam.question_version.not_found": "common.errors.apiCodes.examQuestionVersionNotFound",
  "exam.question.code_not_found": "common.errors.apiCodes.examQuestionCodeNotFound",
  "exam.question.in_use": "common.errors.apiCodes.examQuestionInUse",
  "exam.question.not_found": "common.errors.apiCodes.examQuestionNotFound",
  "exam.question.state_conflict": "common.errors.apiCodes.examQuestionStateConflict",
  "exam.question.validation_failed": "common.errors.apiCodes.examQuestionValidationFailed",
  "exam.review.objective_question_not_reviewable":
    "common.errors.apiCodes.examReviewObjectiveQuestionNotReviewable",
  "exam.runtime.data_contract_invalid": "common.errors.apiCodes.examRuntimeDataContractInvalid",
  "exam.runtime.export_dependency_missing":
    "common.errors.apiCodes.examRuntimeExportDependencyMissing",
  "exam.scoring.attempt_not_found": "common.errors.apiCodes.examScoringAttemptNotFound",
  "exam.scoring.scores_unavailable": "common.errors.apiCodes.examScoringScoresUnavailable",
  "exam.staff_assignment.not_found": "common.errors.apiCodes.examStaffAssignmentNotFound",
  "exam.staff_user.invalid": "common.errors.apiCodes.examStaffUserInvalid",
  "exam.staff_user.not_found": "common.errors.apiCodes.examStaffUserNotFound",
  "exam.user.data_contract_invalid": "common.errors.apiCodes.examUserDataContractInvalid",
  "exam.user.validation_failed": "common.errors.apiCodes.examUserValidationFailed",
  "identity.actor_session_missing": "common.errors.apiCodes.identityActorSessionMissing",
  "instance.action_name_required": "common.errors.apiCodes.instanceActionNameRequired",
  "instance.default_spec_id_invalid": "common.errors.apiCodes.instanceDefaultSpecIdInvalid",
  "instance.diagnostic_kind_required": "common.errors.apiCodes.instanceDiagnosticKindRequired",
  "instance.image_name_required": "common.errors.apiCodes.instanceImageNameRequired",
  "instance.password_required": "common.errors.apiCodes.instancePasswordRequired",
  "instance.qga_reset_password_not_match":
    "common.errors.apiCodes.instanceQgaResetPasswordNotMatch",
  "instance.source_type_required": "common.errors.apiCodes.instanceSourceTypeRequired",
  "instance.username_required": "common.errors.apiCodes.instanceUsernameRequired",
  "micro_lab.auth.data_contract_invalid": "common.errors.apiCodes.microLabAuthDataContractInvalid",
  "micro_lab.member_contract_invalid": "common.errors.apiCodes.microLabMemberContractInvalid",
  "micro_lab.platform.data_contract_invalid":
    "common.errors.apiCodes.microLabPlatformDataContractInvalid",
  "orchestrator_center.requests.summary_invalid":
    "common.errors.apiCodes.orchestratorCenterRequestsSummaryInvalid",
  "orchestrator.topology_action.idempotency_mismatch":
    "common.errors.apiCodes.orchestratorTopologyActionIdempotencyMismatch",
  "orchestrator.topology_action.source_app_mismatch":
    "common.errors.apiCodes.orchestratorTopologyActionSourceAppMismatch",
  "orchestrator.topology_create.idempotency_mismatch":
    "common.errors.apiCodes.orchestratorTopologyCreateIdempotencyMismatch",
  "orchestrator.topology_create.identity_mismatch":
    "common.errors.apiCodes.orchestratorTopologyCreateIdentityMismatch",
  "orchestrator.topology_destroy.idempotency_mismatch":
    "common.errors.apiCodes.orchestratorTopologyDestroyIdempotencyMismatch",
  "orchestrator.topology_destroy.identity_mismatch":
    "common.errors.apiCodes.orchestratorTopologyDestroyIdentityMismatch",
  "orchestrator.topology_extend.idempotency_mismatch":
    "common.errors.apiCodes.orchestratorTopologyExtendIdempotencyMismatch",
  "orchestrator.topology_traffic.idempotency_mismatch":
    "common.errors.apiCodes.orchestratorTopologyTrafficIdempotencyMismatch",
  "platform.asset_center.asset.invalid_metadata_json":
    "common.errors.apiCodes.platformAssetCenterAssetInvalidMetadataJson",
  "platform.asset_center.asset.not_found":
    "common.errors.apiCodes.platformAssetCenterAssetNotFound",
  "platform.asset_center.auth.asset_admin_required":
    "common.errors.apiCodes.platformAssetCenterAuthAssetAdminRequired",
  "platform.asset_center.auth.created_by_mismatch":
    "common.errors.apiCodes.platformAssetCenterAuthCreatedByMismatch",
  "platform.asset_center.auth.internal_actor_user_id_missing":
    "common.errors.apiCodes.platformAssetCenterAuthInternalActorUserIdMissing",
  "platform.asset_center.auth.invalid_bearer_token":
    "common.errors.apiCodes.platformAssetCenterAuthInvalidBearerToken",
  "platform.asset_center.auth.invalid_internal_token":
    "common.errors.apiCodes.platformAssetCenterAuthInvalidInternalToken",
  "platform.asset_center.auth.invalid_sso_payload":
    "common.errors.apiCodes.platformAssetCenterAuthInvalidSsoPayload",
  "platform.asset_center.auth.missing_bearer_token":
    "common.errors.apiCodes.platformAssetCenterAuthMissingBearerToken",
  "platform.asset_center.auth.sso_base_url_not_configured":
    "common.errors.apiCodes.platformAssetCenterAuthSsoBaseUrlNotConfigured",
  "platform.asset_center.auth.sso_lookup_failed":
    "common.errors.apiCodes.platformAssetCenterAuthSsoLookupFailed",
  "platform.asset_center.auth.sso_user_id_missing":
    "common.errors.apiCodes.platformAssetCenterAuthSsoUserIdMissing",
  "platform.asset_center.business_event.inbox_retry_later":
    "common.errors.apiCodes.platformAssetCenterBusinessEventInboxRetryLater",
  "platform.asset_center.business_event.unexpected_retryable_failure":
    "common.errors.apiCodes.platformAssetCenterBusinessEventUnexpectedRetryableFailure",
  "platform.asset_center.object_space.quota_exceeded":
    "common.errors.apiCodes.platformAssetCenterObjectSpaceQuotaExceeded",
  "platform.asset_center.upload_callback.delivery_retryable_failure":
    "common.errors.apiCodes.platformAssetCenterUploadCallbackDeliveryRetryableFailure",
  "platform.asset_center.upload.client_unexpected_error":
    "common.errors.apiCodes.platformAssetCenterUploadClientUnexpectedError",
  "platform.asset_center.upload.complete_missing_asset":
    "common.errors.apiCodes.platformAssetCenterUploadCompleteMissingAsset",
  "platform.asset_center.upload.direct_multipart_contract_invalid":
    "common.errors.apiCodes.platformAssetCenterUploadDirectMultipartContractInvalid",
  "platform.asset_center.upload.filename_required":
    "common.errors.apiCodes.platformAssetCenterUploadFilenameRequired",
  "platform.asset_center.upload.invalid_file":
    "common.errors.apiCodes.platformAssetCenterUploadInvalidFile",
  "platform.asset_center.upload.invalid_token":
    "common.errors.apiCodes.platformAssetCenterUploadInvalidToken",
  "platform.asset_center.upload.multipart_part_etag_missing":
    "common.errors.apiCodes.platformAssetCenterUploadMultipartPartEtagMissing",
  "platform.asset_center.upload.multipart_part_failed":
    "common.errors.apiCodes.platformAssetCenterUploadMultipartPartFailed",
  "platform.asset_center.upload.multipart_part_presign_contract_invalid":
    "common.errors.apiCodes.platformAssetCenterUploadMultipartPartPresignContractInvalid",
  "platform.asset_center.upload.object_key_mismatch":
    "common.errors.apiCodes.platformAssetCenterUploadObjectKeyMismatch",
  "platform.asset_center.upload.request_conflict":
    "common.errors.apiCodes.platformAssetCenterUploadRequestConflict",
  "platform.asset_center.upload.request_contract_invalid":
    "common.errors.apiCodes.platformAssetCenterUploadRequestContractInvalid",
  "platform.asset_center.upload.request_id_owned_by_another_user":
    "common.errors.apiCodes.platformAssetCenterUploadRequestIdOwnedByAnotherUser",
  "platform.asset_center.upload.request_not_found":
    "common.errors.apiCodes.platformAssetCenterUploadRequestNotFound",
  "platform.asset_center.upload.token_missing":
    "common.errors.apiCodes.platformAssetCenterUploadTokenMissing",
  "platform.asset.dependency_unavailable":
    "common.errors.apiCodes.platformAssetDependencyUnavailable",
  "platform.asset.in_use": "common.errors.apiCodes.platformAssetInUse",
  "platform.asset.internal.error": "common.errors.apiCodes.platformAssetInternalError",
  "platform.asset.invalid_metadata_json": "common.errors.apiCodes.platformAssetInvalidMetadataJson",
  "platform.asset.not_found": "common.errors.apiCodes.platformAssetNotFound",
  "platform.asset.provider_unavailable": "common.errors.apiCodes.platformAssetProviderUnavailable",
  "platform.asset.upload_size_exceeded": "common.errors.apiCodes.platformAssetUploadSizeExceeded",
  "platform.asset.upstream_invalid_response":
    "common.errors.apiCodes.platformAssetUpstreamInvalidResponse",
  "platform.auth.access_token_invalid":
    "common.errors.apiCodeReasons.platformAuth.accessTokenInvalid",
  "platform.auth.account_temporarily_locked":
    "common.errors.apiCodeReasons.platformAuth.accountTemporarilyLocked",
  "platform.auth.authorization_scheme_unsupported":
    "common.errors.apiCodeReasons.platformAuth.authorizationSchemeUnsupported",
  "platform.auth.bff_app_session.expired":
    "common.errors.apiCodeReasons.platformAuth.bffAppSessionExpired",
  "platform.auth.bff_app_session.invalid":
    "common.errors.apiCodeReasons.platformAuth.bffAppSessionInvalid",
  "platform.auth.bff_app_session.invalidated":
    "common.errors.apiCodeReasons.platformAuth.bffAppSessionInvalidated",
  "platform.auth.bff_authorization_state.invalid":
    "common.errors.apiCodeReasons.platformAuth.bffAuthorizationStateInvalid",
  "platform.auth.bff_authorization_transaction.invalid":
    "common.errors.apiCodeReasons.platformAuth.bffAuthorizationTransactionInvalid",
  "platform.auth.bff_authorization_transaction.invalidated":
    "common.errors.apiCodeReasons.platformAuth.bffAuthorizationTransactionInvalidated",
  "platform.auth.bff_client_request.invalid":
    "common.errors.apiCodeReasons.platformAuth.bffClientRequestInvalid",
  "platform.auth.bff_confidential_client_required":
    "common.errors.apiCodeReasons.platformAuth.bffConfidentialClientRequired",
  "platform.auth.bff_issuer.not_configured":
    "common.errors.apiCodeReasons.platformAuth.bffIssuerNotConfigured",
  "platform.auth.bff_prompt.invalid": "common.errors.apiCodeReasons.platformAuth.bffPromptInvalid",
  "platform.auth.bff_return_path.invalid":
    "common.errors.apiCodeReasons.platformAuth.bffReturnPathInvalid",
  "platform.auth.bff_session.contract_invalid":
    "common.errors.apiCodeReasons.platformAuth.bffSessionContractInvalid",
  "platform.auth.bff_session.dependency_unavailable":
    "common.errors.apiCodeReasons.platformAuth.bffSessionDependencyUnavailable",
  "platform.auth.browser_session_expired":
    "common.errors.apiCodeReasons.platformAuth.browserSessionExpired",
  "platform.auth.browser_session_invalid":
    "common.errors.apiCodeReasons.platformAuth.browserSessionInvalid",
  "platform.auth.browser_session_invalidated":
    "common.errors.apiCodeReasons.platformAuth.browserSessionInvalidated",
  "platform.auth.client_auth_method_unsupported":
    "common.errors.apiCodeReasons.platformAuth.clientAuthMethodUnsupported",
  "platform.auth.client_id_mismatch": "common.errors.apiCodeReasons.platformAuth.clientIdMismatch",
  "platform.auth.client_id_required": "common.errors.apiCodeReasons.platformAuth.clientIdRequired",
  "platform.auth.client_secret_basic_required":
    "common.errors.apiCodeReasons.platformAuth.clientSecretBasicRequired",
  "platform.auth.client_secret_required":
    "common.errors.apiCodeReasons.platformAuth.clientSecretRequired",
  "platform.auth.exercise_manager_required":
    "common.errors.apiCodeReasons.platformAuth.exerciseManagerRequired",
  "platform.auth.invalid_app_session":
    "common.errors.apiCodeReasons.platformAuth.invalidAppSession",
  "platform.auth.invalid_bearer_token":
    "common.errors.apiCodeReasons.platformAuth.invalidBearerToken",
  "platform.auth.invalid_client_credentials":
    "common.errors.apiCodeReasons.platformAuth.invalidClientCredentials",
  "platform.auth.invalid_credentials":
    "common.errors.apiCodeReasons.platformAuth.invalidCredentials",
  "platform.auth.invalid_token": "common.errors.apiCodeReasons.platformAuth.invalidToken",
  "platform.auth.missing_bearer_token":
    "common.errors.apiCodeReasons.platformAuth.missingBearerToken",
  "platform.auth.multiple_client_auth_methods_forbidden":
    "common.errors.apiCodeReasons.platformAuth.multipleClientAuthMethodsForbidden",
  "platform.auth.platform_admin_required":
    "common.errors.apiCodeReasons.platformAuth.platformAdminRequired",
  "platform.auth.platform_manager_required":
    "common.errors.apiCodeReasons.platformAuth.platformManagerRequired",
  "platform.auth.portal_member_required":
    "common.errors.apiCodeReasons.platformAuth.portalMemberRequired",
  "platform.auth.public_client_introspection_forbidden":
    "common.errors.apiCodeReasons.platformAuth.publicClientIntrospectionForbidden",
  "platform.auth.refresh_token_expired":
    "common.errors.apiCodeReasons.platformAuth.refreshTokenExpired",
  "platform.auth.refresh_token_invalid":
    "common.errors.apiCodeReasons.platformAuth.refreshTokenInvalid",
  "platform.auth.refresh_token_invalidated":
    "common.errors.apiCodeReasons.platformAuth.refreshTokenInvalidated",
  "platform.auth.refresh_token_required":
    "common.errors.apiCodeReasons.platformAuth.refreshTokenRequired",
  "platform.auth.request.forbidden": "common.errors.apiCodeReasons.platformAuth.requestForbidden",
  "platform.auth.request.unauthorized":
    "common.errors.apiCodeReasons.platformAuth.requestUnauthorized",
  "platform.auth.session_invalidated":
    "common.errors.apiCodeReasons.platformAuth.sessionInvalidated",
  "platform.auth.sso_not_enabled": "common.errors.apiCodeReasons.platformAuth.ssoNotEnabled",
  "platform.auth.teacher_required": "common.errors.apiCodeReasons.platformAuth.teacherRequired",
  "platform.auth.token_required": "common.errors.apiCodeReasons.platformAuth.tokenRequired",
  "platform.business_reference.auth.admin_required":
    "common.errors.apiCodes.platformBusinessReferenceAuthAdminRequired",
  "platform.business_reference.auth.internal_actor_user_id_required":
    "common.errors.apiCodes.platformBusinessReferenceAuthInternalActorUserIdRequired",
  "platform.business_reference.auth.invalid_internal_token":
    "common.errors.apiCodes.platformBusinessReferenceAuthInvalidInternalToken",
  "platform.business_reference.auth.invalid_sso_user_payload":
    "common.errors.apiCodes.platformBusinessReferenceAuthInvalidSsoUserPayload",
  "platform.business_reference.auth.invalid_token":
    "common.errors.apiCodes.platformBusinessReferenceAuthInvalidToken",
  "platform.business_reference.auth.missing_bearer_token":
    "common.errors.apiCodes.platformBusinessReferenceAuthMissingBearerToken",
  "platform.business_reference.auth.sso_integration_disabled":
    "common.errors.apiCodes.platformBusinessReferenceAuthSsoIntegrationDisabled",
  "platform.business_reference.auth.sso_unavailable":
    "common.errors.apiCodes.platformBusinessReferenceAuthSsoUnavailable",
  "platform.business_reference.reference.not_found":
    "common.errors.apiCodes.platformBusinessReferenceReferenceNotFound",
  "platform.business_reference.relation_type.not_active":
    "common.errors.apiCodes.platformBusinessReferenceRelationTypeNotActive",
  "platform.business_reference.request.invalid_choice":
    "common.errors.apiCodes.platformBusinessReferenceRequestInvalidChoice",
  "platform.business_reference.request.required_field":
    "common.errors.apiCodes.platformBusinessReferenceRequestRequiredField",
  "platform.business_reference.resource_type.not_active":
    "common.errors.apiCodes.platformBusinessReferenceResourceTypeNotActive",
  "platform.capability_graph.auth.admin_required":
    "common.errors.apiCodes.platformCapabilityGraphAuthAdminRequired",
  "platform.capability_graph.auth.invalid_sso_user_payload":
    "common.errors.apiCodes.platformCapabilityGraphAuthInvalidSsoUserPayload",
  "platform.capability_graph.auth.invalid_token":
    "common.errors.apiCodes.platformCapabilityGraphAuthInvalidToken",
  "platform.capability_graph.auth.missing_bearer_token":
    "common.errors.apiCodes.platformCapabilityGraphAuthMissingBearerToken",
  "platform.capability_graph.auth.sso_integration_disabled":
    "common.errors.apiCodes.platformCapabilityGraphAuthSsoIntegrationDisabled",
  "platform.capability_graph.auth.sso_unavailable":
    "common.errors.apiCodes.platformCapabilityGraphAuthSsoUnavailable",
  "platform.capability_graph.capability.key_conflict":
    "common.errors.apiCodes.platformCapabilityGraphCapabilityKeyConflict",
  "platform.capability_graph.capability.key_sequence_exhausted":
    "common.errors.apiCodes.platformCapabilityGraphCapabilityKeySequenceExhausted",
  "platform.capability_graph.capability.not_found":
    "common.errors.apiCodes.platformCapabilityGraphCapabilityNotFound",
  "platform.capability_graph.ksa_category.category_key_conflict":
    "common.errors.apiCodes.platformCapabilityGraphCategoryKeyConflict",
  "platform.capability_graph.ksa_category.not_found":
    "common.errors.apiCodes.platformCapabilityGraphKsaCategoryNotFound",
  "platform.capability_graph.ksa_category.parent_not_found":
    "common.errors.apiCodes.platformCapabilityGraphParentKsaCategoryNotFound",
  "platform.capability_graph.ksa_category.parent_not_top_level":
    "common.errors.apiCodes.platformCapabilityGraphParentKsaCategoryNotTopLevel",
  "platform.capability_graph.ksa_category.primary_not_found":
    "common.errors.apiCodes.platformCapabilityGraphPrimaryKsaCategoryNotFound",
  "platform.capability_graph.request.invalid_choice":
    "common.errors.apiCodes.platformCapabilityGraphRequestInvalidChoice",
  "platform.capability_graph.request.required_field":
    "common.errors.apiCodes.platformCapabilityGraphRequestRequiredField",
  "platform.contract.environment_instance_id_invalid":
    "common.errors.apiCodes.platformContractEnvironmentInstanceIdInvalid",
  "platform.contract.environment_instance_id_missing":
    "common.errors.apiCodes.platformContractEnvironmentInstanceIdMissing",
  "platform.environment.application_image.active_os_required":
    "common.errors.apiCodes.platformEnvironmentApplicationImageActiveOsRequired",
  "platform.environment.application_image.source_base_os_required":
    "common.errors.apiCodes.platformEnvironmentApplicationImageSourceBaseOsRequired",
  "platform.environment.base_image.active_os_required":
    "common.errors.apiCodes.platformEnvironmentBaseImageActiveOsRequired",
  "platform.environment.business_event.unexpected_retryable_failure":
    "common.errors.apiCodes.platformEnvironmentBusinessEventUnexpectedRetryableFailure",
  "platform.environment.business_reference.blocking_references":
    "common.errors.apiCodes.platformEnvironmentBusinessReferenceBlockingReferences",
  "platform.environment.business_reference.check_failed":
    "common.errors.apiCodes.platformEnvironmentBusinessReferenceCheckFailed",
  "platform.environment.business_reference.check_unavailable":
    "common.errors.apiCodes.platformEnvironmentBusinessReferenceCheckUnavailable",
  "platform.environment.custom_image.active_os_required":
    "common.errors.apiCodes.platformEnvironmentCustomImageActiveOsRequired",
  "platform.environment.custom_image.source_base_os_required":
    "common.errors.apiCodes.platformEnvironmentCustomImageSourceBaseOsRequired",
  "platform.environment.image_port_service_protocol.archived_read_only":
    "common.errors.apiCodes.platformEnvironmentImagePortServiceProtocolArchivedReadOnly",
  "platform.environment.image_port_service_protocol.inactive":
    "common.errors.apiCodes.platformEnvironmentImagePortServiceProtocolInactive",
  "platform.environment.image_port_service_protocol.name_conflict":
    "common.errors.apiCodes.platformEnvironmentImagePortServiceProtocolNameConflict",
  "platform.environment.image_port_service_protocol.not_found":
    "common.errors.apiCodes.platformEnvironmentImagePortServiceProtocolNotFound",
  "platform.environment.image.router_implementation_invalid":
    "common.errors.apiCodes.platformEnvironmentImageRouterImplementationInvalid",
  "platform.environment.os_version.archived_read_only":
    "common.errors.apiCodes.platformEnvironmentOsVersionArchivedReadOnly",
  "platform.environment.os_version.inactive":
    "common.errors.apiCodes.platformEnvironmentOsVersionInactive",
  "platform.environment.os_version.name_conflict":
    "common.errors.apiCodes.platformEnvironmentOsVersionNameConflict",
  "platform.environment.os_version.not_found":
    "common.errors.apiCodes.platformEnvironmentOsVersionNotFound",
  "platform.environment.topology_template.archived_read_only":
    "common.errors.apiCodes.platformEnvironmentTopologyTemplateArchivedReadOnly",
  "platform.environment.topology_version.archived_read_only":
    "common.errors.apiCodes.platformEnvironmentTopologyVersionArchivedReadOnly",
  "platform.environment.topology_version.published_immutable":
    "common.errors.apiCodes.platformEnvironmentTopologyVersionPublishedImmutable",
  "platform.environment.topology.artifact_contract_invalid":
    "common.errors.apiCodes.platformEnvironmentTopologyArtifactContractInvalid",
  "platform.environment.topology.publish_validation_failed":
    "common.errors.apiCodes.platformEnvironmentTopologyPublishValidationFailed",
  "platform.environment.topology.snapshot_embedded_image_forbidden":
    "common.errors.apiCodes.platformEnvironmentTopologySnapshotEmbeddedImageForbidden",
  "platform.execution_fabric.auth.actor_user_id_required":
    "common.errors.apiCodes.platformExecutionFabricAuthActorUserIdRequired",
  "platform.execution_fabric.auth.internal_token_invalid":
    "common.errors.apiCodes.platformExecutionFabricAuthInternalTokenInvalid",
  "platform.execution_fabric.business_event.handler_retryable_failed":
    "common.errors.apiCodes.platformExecutionFabricBusinessEventHandlerRetryableFailed",
  "platform.execution_fabric.business_event.inbox_retry_later":
    "common.errors.apiCodes.platformExecutionFabricBusinessEventInboxRetryLater",
  "platform.execution_fabric.business_event.unexpected_retryable_failure":
    "common.errors.apiCodes.platformExecutionFabricBusinessEventUnexpectedRetryableFailure",
  "platform.execution_fabric.internal.error":
    "common.errors.apiCodes.platformExecutionFabricInternalError",
  "platform.execution_fabric.runtime_admission.capacity_exhausted":
    "common.errors.apiCodes.platformExecutionFabricRuntimeAdmissionCapacityExhausted",
  "platform.execution_fabric.user_virtualization_quota.exceeded":
    "common.errors.apiCodes.platformExecutionFabricUserVirtualizationQuotaExceeded",
  "platform.execution_fabric.vm_agent.bootstrap_token_expired":
    "common.errors.apiCodes.platformExecutionFabricVmAgentBootstrapTokenExpired",
  "platform.execution.expired_recovery.mark_expired_failed":
    "common.errors.apiCodes.platformExecutionExpiredRecoveryMarkExpiredFailed",
  "platform.execution.expired_recovery.persisted_selection_mode_invalid":
    "common.errors.apiCodes.platformExecutionExpiredRecoveryPersistedSelectionModeInvalid",
  "platform.execution.expired_recovery.persisted_status_invalid":
    "common.errors.apiCodes.platformExecutionExpiredRecoveryPersistedStatusInvalid",
  "platform.execution.expired_recovery.submit_destroy_after_completed_topology_destroy_failed":
    "common.errors.apiCodes.platformExecutionExpiredRecoverySubmitDestroyAfterCompletedTopologyDestroyFailed",
  "platform.execution.expired_recovery.submit_destroy_failed":
    "common.errors.apiCodes.platformExecutionExpiredRecoverySubmitDestroyFailed",
  "platform.execution.expired_recovery.submit_topology_destroy_failed":
    "common.errors.apiCodes.platformExecutionExpiredRecoverySubmitTopologyDestroyFailed",
  "platform.execution.instance.qga_reset_password_failed":
    "common.errors.apiCodes.platformExecutionInstanceQgaResetPasswordFailed",
  "platform.execution.instance.vm_agent_install_failed":
    "common.errors.apiCodes.platformExecutionInstanceVmAgentInstallFailed",
  "platform.intelligence.audit.token_usage_invalid":
    "common.errors.apiCodes.platformIntelligenceAuditTokenUsageInvalid",
  "platform.intelligence.provider.http_error":
    "common.errors.apiCodes.platformIntelligenceProviderHttpError",
  "platform.intelligence.provider.models_payload_invalid":
    "common.errors.apiCodes.platformIntelligenceProviderModelsPayloadInvalid",
  "platform.intelligence.provider.network_error":
    "common.errors.apiCodes.platformIntelligenceProviderNetworkError",
  "platform.intelligence.provider.request_failed":
    "common.errors.apiCodes.platformIntelligenceProviderRequestFailed",
  "platform.intelligence.provider.usage_payload_invalid":
    "common.errors.apiCodes.platformIntelligenceProviderUsagePayloadInvalid",
  "platform.intelligence.task.output_payload_invalid":
    "common.errors.apiCodes.platformIntelligenceTaskOutputPayloadInvalid",
  "platform.knowledge_library.auth.invalid_app_session":
    "common.errors.apiCodes.platformKnowledgeLibraryAuthInvalidAppSession",
  "platform.oidc.secure_context_required":
    "common.errors.apiCodes.platformOidcSecureContextRequired",
  "platform.ops_center.auth.invalid_app_session":
    "common.errors.apiCodes.platformOpsCenterAuthInvalidAppSession",
  "platform.ops_center.auth.invalid_sso_user_payload":
    "common.errors.apiCodes.platformOpsCenterAuthInvalidSsoUserPayload",
  "platform.ops_center.auth.invalid_token":
    "common.errors.apiCodes.platformOpsCenterAuthInvalidToken",
  "platform.ops_center.auth.missing_bearer_token":
    "common.errors.apiCodes.platformOpsCenterAuthMissingBearerToken",
  "platform.ops_center.auth.platform_admin_required":
    "common.errors.apiCodes.platformOpsCenterAuthPlatformAdminRequired",
  "platform.ops_center.auth.sso_integration_disabled":
    "common.errors.apiCodes.platformOpsCenterAuthSsoIntegrationDisabled",
  "platform.ops_center.auth.sso_unavailable":
    "common.errors.apiCodes.platformOpsCenterAuthSsoUnavailable",
  "platform.ops_center.endpoint_manifest.contract_invalid":
    "common.errors.apiCodes.platformOpsCenterEndpointManifestContractInvalid",
  "platform.ops_center.entrypoint.contract_invalid":
    "common.errors.apiCodes.platformOpsCenterEntrypointContractInvalid",
  "platform.ops_center.module.disappeared_after_service_action":
    "common.errors.apiCodes.platformOpsCenterModuleDisappearedAfterServiceAction",
  "platform.ops_center.module.not_found": "common.errors.apiCodes.platformOpsCenterModuleNotFound",
  "platform.ops_center.module.not_registered":
    "common.errors.apiCodes.platformOpsCenterModuleNotRegistered",
  "platform.ops_center.module.systemd_unit_required":
    "common.errors.apiCodes.platformOpsCenterModuleSystemdUnitRequired",
  "platform.ops_center.probe.contract_invalid":
    "common.errors.apiCodes.platformOpsCenterProbeContractInvalid",
  "platform.ops_center.read_model.contract_invalid":
    "common.errors.apiCodes.platformOpsCenterReadModelContractInvalid",
  "platform.ops_center.request.invalid_choice":
    "common.errors.apiCodes.platformOpsCenterRequestInvalidChoice",
  "platform.ops_center.request.object_required":
    "common.errors.apiCodes.platformOpsCenterRequestObjectRequired",
  "platform.ops_center.request.required_field":
    "common.errors.apiCodes.platformOpsCenterRequestRequiredField",
  "platform.ops_center.service_action.not_allowed":
    "common.errors.apiCodes.platformOpsCenterServiceActionNotAllowed",
  "platform.ops_center.service_action.policy_invalid":
    "common.errors.apiCodes.platformOpsCenterServiceActionPolicyInvalid",
  "platform.ops_center.service_endpoint_registry.contract_invalid":
    "common.errors.apiCodes.platformOpsCenterServiceEndpointRegistryContractInvalid",
  "platform.orchestrator.auth.conflicting_authentication":
    "common.errors.apiCodes.platformOrchestratorAuthConflictingAuthentication",
  "platform.orchestrator.auth.invalid_app_session":
    "common.errors.apiCodes.platformOrchestratorAuthInvalidAppSession",
  "platform.orchestrator.auth.invalid_internal_context":
    "common.errors.apiCodes.platformOrchestratorAuthInvalidInternalContext",
  "platform.orchestrator.auth.invalid_internal_token":
    "common.errors.apiCodes.platformOrchestratorAuthInvalidInternalToken",
  "platform.orchestrator.auth.invalid_sso_user_payload":
    "common.errors.apiCodes.platformOrchestratorAuthInvalidSsoUserPayload",
  "platform.orchestrator.auth.invalid_token":
    "common.errors.apiCodes.platformOrchestratorAuthInvalidToken",
  "platform.orchestrator.auth.missing_bearer_token":
    "common.errors.apiCodes.platformOrchestratorAuthMissingBearerToken",
  "platform.orchestrator.auth.sso_integration_disabled":
    "common.errors.apiCodes.platformOrchestratorAuthSsoIntegrationDisabled",
  "platform.orchestrator.auth.sso_unavailable":
    "common.errors.apiCodes.platformOrchestratorAuthSsoUnavailable",
  "platform.orchestrator.dev_vpcs_smoke.admin_required":
    "common.errors.apiCodes.platformOrchestratorDevVpcsSmokeAdminRequired",
  "platform.orchestrator.dev_vpcs_smoke.environment_center_invalid":
    "common.errors.apiCodes.platformOrchestratorDevVpcsSmokeEnvironmentCenterInvalid",
  "platform.orchestrator.dev_vpcs_smoke.idempotency_mismatch":
    "common.errors.apiCodes.platformOrchestratorDevVpcsSmokeIdempotencyMismatch",
  "platform.orchestrator.dev_vpcs_smoke.unavailable":
    "common.errors.apiCodes.platformOrchestratorDevVpcsSmokeUnavailable",
  "platform.orchestrator.instance_create.quota_bypass_admin_required":
    "common.errors.apiCodes.platformOrchestratorInstanceCreateQuotaBypassAdminRequired",
  "platform.orchestrator.instance_create.quota_bypass_unavailable":
    "common.errors.apiCodes.platformOrchestratorInstanceCreateQuotaBypassUnavailable",
  "platform.orchestrator.instance_create.request_missing_after_submit":
    "common.errors.apiCodes.platformOrchestratorInstanceCreateRequestMissingAfterSubmit",
  "platform.orchestrator.instance_destroy.request_missing_after_submit":
    "common.errors.apiCodes.platformOrchestratorInstanceDestroyRequestMissingAfterSubmit",
  "platform.orchestrator.request.not_found":
    "common.errors.apiCodes.platformOrchestratorRequestNotFound",
  "platform.orchestrator.step.not_found": "common.errors.apiCodes.platformOrchestratorStepNotFound",
  "platform.orchestrator.topology_create.environment_center_invalid":
    "common.errors.apiCodes.platformOrchestratorTopologyCreateEnvironmentCenterInvalid",
  "platform.orchestrator.topology_create.execution_fabric_unavailable":
    "common.errors.apiCodes.platformOrchestratorTopologyCreateExecutionFabricUnavailable",
  "platform.orchestrator.topology_create.request_missing_after_submit":
    "common.errors.apiCodes.platformOrchestratorTopologyCreateRequestMissingAfterSubmit",
  "platform.orchestrator.topology_extend.execution_fabric_unavailable":
    "common.errors.apiCodes.platformOrchestratorTopologyExtendExecutionFabricUnavailable",
  "platform.task_center.auth.invalid_internal_token":
    "common.errors.apiCodes.platformTaskCenterAuthInvalidInternalToken",
  "platform.task_center.orchestrator.scope_invalid":
    "common.errors.apiCodes.platformTaskCenterOrchestratorScopeInvalid",
  "platform.task_center.prepare.batch_item_failed":
    "common.errors.apiCodes.platformTaskCenterPrepareBatchItemFailed",
  "platform.task_center.prepare.idempotency_conflict":
    "common.errors.apiCodes.platformTaskCenterPrepareIdempotencyConflict",
  "platform.task_center.prepare.idempotency_state_corrupted":
    "common.errors.apiCodes.platformTaskCenterPrepareIdempotencyStateCorrupted",
  "platform.task_center.request.invalid": "common.errors.apiCodes.platformTaskCenterRequestInvalid",
  "platform.task_center.runtime_event.not_found":
    "common.errors.apiCodes.platformTaskCenterRuntimeEventNotFound",
  "platform.task_center.task.not_found": "common.errors.apiCodes.platformTaskCenterTaskNotFound",
  "platform.task_center.task.not_retryable":
    "common.errors.apiCodes.platformTaskCenterTaskNotRetryable",
  "platform.task_center.task.retry_request_id_conflict":
    "common.errors.apiCodes.platformTaskCenterRetryRequestIdConflict",
  "platform.task_center.task.retry_task_id_missing":
    "common.errors.apiCodes.platformTaskCenterRetryTaskIdMissing",
  "platform.tools_library.contract.invalid_enum":
    "common.errors.apiCodes.platformToolsLibraryContractInvalidEnum",
  "platform.vulnerability_library.import_event.upload_missing":
    "common.errors.apiCodes.platformVulnerabilityLibraryImportEventUploadMissing",
  "platform.vulnerability_library.import_event.worker_busy":
    "common.errors.apiCodes.platformVulnerabilityLibraryImportEventWorkerBusy",
  "portal.root_element_missing": "common.errors.apiCodes.portalRootElementMissing",
  "redblue.business_event.inbox_retry_later":
    "common.errors.apiCodes.redblueBusinessEventInboxRetryLater",
  "redblue.business_event.unexpected_retryable_failure":
    "common.errors.apiCodes.redblueBusinessEventUnexpectedRetryableFailure",
  "redblue.member_contract_invalid": "common.errors.apiCodes.redblueMemberContractInvalid",
  "redblue.platform.data_contract_invalid":
    "common.errors.apiCodes.redbluePlatformDataContractInvalid",
  "remote.access.api_empty_response": "common.errors.apiCodes.remoteAccessApiEmptyResponse",
  "runtime.docker_default_address_pools_base_required":
    "common.errors.apiCodes.runtimeDockerDefaultAddressPoolsBaseRequired",
  "runtime.docker_default_address_pools_item_invalid":
    "common.errors.apiCodes.runtimeDockerDefaultAddressPoolsItemInvalid",
  "runtime.docker_default_address_pools_not_array":
    "common.errors.apiCodes.runtimeDockerDefaultAddressPoolsNotArray",
  "runtime.docker_default_address_pools_size_invalid":
    "common.errors.apiCodes.runtimeDockerDefaultAddressPoolsSizeInvalid",
  "runtime.docker_default_address_pools_size_out_of_range":
    "common.errors.apiCodes.runtimeDockerDefaultAddressPoolsSizeOutOfRange",
  "runtime.environment_instances.items_invalid":
    "common.errors.apiCodes.runtimeEnvironmentInstancesItemsInvalid",
  "runtime.environment_instances.list_summary.item_invalid":
    "common.errors.apiCodes.runtimeEnvironmentInstancesListSummaryItemInvalid",
  "runtime.environment_instances.summary.bucket_invalid":
    "common.errors.apiCodes.runtimeEnvironmentInstancesSummaryBucketInvalid",
  "runtime.environment_instances.summary.group_invalid":
    "common.errors.apiCodes.runtimeEnvironmentInstancesSummaryGroupInvalid",
  "runtime.environment_instances.summary.invalid":
    "common.errors.apiCodes.runtimeEnvironmentInstancesSummaryInvalid",
  "sso.oidc_access_token_invalid": "common.errors.apiCodes.ssoOidcAccessTokenInvalid",
  "sso.oidc_access_token_missing": "common.errors.apiCodes.ssoOidcAccessTokenMissing",
  "sso.oidc_authorization_startup_timeout":
    "common.errors.apiCodes.ssoOidcAuthorizationStartupTimeout",
  "sso.oidc_callback_access_token_invalid":
    "common.errors.apiCodes.ssoOidcCallbackAccessTokenInvalid",
  "sso.oidc_callback_access_token_missing":
    "common.errors.apiCodes.ssoOidcCallbackAccessTokenMissing",
  "sso.oidc_client_id_invalid": "common.errors.apiCodes.ssoOidcClientIdInvalid",
  "sso.oidc_client_id_missing": "common.errors.apiCodes.ssoOidcClientIdMissing",
  "tools_library.download.filename_missing":
    "common.errors.apiCodes.toolsLibraryDownloadFilenameMissing",
  "topology.create_request_id_required": "common.errors.apiCodes.topologyCreateRequestIdRequired",
  "topology.extend_minutes_invalid": "common.errors.apiCodes.topologyExtendMinutesInvalid",
  "topology.extend_minutes_out_of_range": "common.errors.apiCodes.topologyExtendMinutesOutOfRange",
  "topology.topology_instance_id_invalid":
    "common.errors.apiCodes.topologyTopologyInstanceIdInvalid",
};
